import React from 'react';

import Performance from '../../components/Prospecting/Performance';

function PerformanceView() {
  return (
    <Performance />
  );
}

export default PerformanceView;
